import { useCallback, useState } from "react";

import { Button, Menu, Position } from "@blueprintjs/core";

import { Popover } from "@/components/helpers/ui/blueprint-overrides/Popover";

interface MoreMenuProps {
  children: React.ReactNode;
  useSpanTrigger?: boolean;
}

export function MoreMenu({ children, useSpanTrigger = false }: MoreMenuProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      handleClose();
    },
    [handleClose],
  );

  const triggerProps = {
    style: { minHeight: 36 },
    onClick: (e: React.MouseEvent<HTMLElement>) => {
      e.preventDefault();
      e.stopPropagation();
      setIsOpen(!isOpen);
    },
  };

  return (
    <Popover
      content={
        <Menu className="bas" onClick={handleClick}>
          {children}
        </Menu>
      }
      canEscapeKeyClose={true}
      position={Position.BOTTOM_RIGHT}
      usePortal={true}
      onClose={handleClose}
      isOpen={isOpen}
      minimal={true}
      modifiers={{
        arrow: { enabled: false },
      }}
    >
      {useSpanTrigger ? (
        <span
          {...triggerProps}
          className="bp5-button bp5-minimal inline-flex cursor-pointer items-center justify-center rounded px-2"
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              e.stopPropagation();
              setIsOpen(!isOpen);
            }
          }}
        >
          <span className="bp5-icon bp5-icon-more" />
        </span>
      ) : (
        <Button {...triggerProps} minimal={true} icon="more" />
      )}
    </Popover>
  );
}
